import request from 'config/apiConfig';

export const getChannelsByMarketer = (payload: { marketerId: string; size: number; page: number }) => {
  return request.get(`channel/channels/marketer`, {
    params: { id: payload.marketerId, size: payload.size, page: payload.page, sort: 'created,desc' }
  });
};

export const getStreamsByChannel = (payload: { channelId: string }) => {
  return request.get(`channel/streams/channel`, {
    params: { id: payload.channelId, size: 1000, sort: 'created,desc' }
  });
};

export const getPlacementsByStream = (payload: { streamnId: string }) => {
  return request.get(`channel/placements/stream`, {
    params: { id: payload.streamnId, size: 1000, sort: 'created,desc' }
  });
};

export const postChannelContent = (payload: any) => {
  return request.post(`channel/channels/create`, payload);
};

export const putGenerateClientId = (payload: { channelId: string }) => {
  return request.put(`channel/channels/${payload.channelId}/generateKey`, {});
};

export const putUpdateChannelDomains = (payload: { channelId: string; domains: string[] }) => {
  return request.put(`channel/channels/${payload.channelId}/domains`, { domains: payload.domains });
};
